import { AccountFilterOutlineIcon } from './AccountFilterOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 4C7A5C71-F3C9-4BD7-B123-C71BE81CAFB7
 * name account-filter-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-filter-outline.svg
 * tags
 * - Account / User 
 */
export const LeadsOutlineIcon = AccountFilterOutlineIcon;
export default LeadsOutlineIcon